import { ChangeLossControlCardsLoading, ChangeLossControlDays, ChangeLossControlDaysLoading, changeLossControlDonutData, 
    changeLossControlDonutDataTotal, ChangeLossControlCards, LogOut, ChangeLossControlStatus } from "../../Redux/Actions/index.js"
import { store } from "../../Redux/Store/index.js"
import { toast } from "react-toastify";
import config from "../../Config/config.json";
import { ControlePerdasRequest } from "./requests.ts"
import { getDataString } from "../../util/Months.js";
import i18n from "../../Config/i18n.js";

export class ControlePerdasService {
    constructor(){
        this.ControlePerdasRequest = new ControlePerdasRequest();
        this.cards = {
            0: [],
        }
        this.initialCard ={
            0: [
                {
                    "Active": false,
                    "type": 0,
                    "focus": true,
                },
                {
                    "Active": false,
                    "type": 0,
                },
                {
                    "Active": false,
                    "type": 0,
                },
                {
                    "Active": false,
                    "type": 0,
                },
                {
                    "Active": false,
                    "type": 0,
                }
            ]
        }
        this.equipamentosList = [];
        this.equipamento = '';
        this.cardtochange = null;
        this.tempposition = -1;
    }

    // Carrega os cards de acordo com o dia
    async loadCards (data){
        try {
            store.dispatch(ChangeLossControlCardsLoading(true));
            let mewCards = await this.ControlePerdasRequest.CardsRequest(data);
            await this.generateCards(mewCards);
            store.dispatch(ChangeLossControlCardsLoading(false));
        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            this.cards = this.initialCard;
            store.dispatch(ChangeLossControlCards(this.initialCard));
            this.formatDayData({}, 'SD');
            store.dispatch(ChangeLossControlCardsLoading(false));
            return;
        }
    }

    // Gera os cards no formato correto
    async generateCards(newCards) {

        if (JSON.parse(localStorage.getItem('AugenCard' + this.equipamento))) {
            this.generateOrderCards(newCards);
            return;
        }

        let Tempcards = {
            0: []
        };

        // 🔹 DISTRIBUIÇÃO DOS CARDS
        newCards.forEach(card => {
            Tempcards[0].push(card);

        });

        // 🔹 FOCO INICIAL
        Tempcards[0][0].focus = true;

        if (Tempcards[0][0].id !== undefined) {
            // this.getDayData(
            //     Tempcards[0][0].id,
            //     Tempcards[0][0].key,
            //     Tempcards[0][0].name,
            //     Tempcards[0][0].idEquipment
            // );
            store.dispatch(ChangeLossControlStatus(Tempcards[0][0].status));
        }

        this.cards = Tempcards;

        try {
            localStorage.setItem(
                'AugenCard' + this.equipamento,
                JSON.stringify(Tempcards)
            );
        } catch (error) {}

        if (this.search) {
            Tempcards = this.FilterCards(this.search);
        }

        store.dispatch(
            ChangeLossControlCards(
                JSON.parse(JSON.stringify(Tempcards)),
                Tempcards[0][0].name
            )
        );
    }


    // Altera o card que está em foco
    changeFocus(cardid, indice, key, idEquipment){
        try {
            let newIndex = 0;
            let focusCard;
            let oldCard;
            let status = 0;
            this.cards[0].map((card, index) => {
                if(card.id === cardid && card.key === key && card.idEquipment === idEquipment){
                    focusCard = card;
                    card.focus = true;
                    status = card.status;
                }else if(card.focus === true){
                    newIndex = index;
                    oldCard = card;
                    card.focus = false;
                }
                return card;
            })
            this.cards[0][newIndex] = focusCard;
            this.cards[0][indice] = oldCard;
            let name = focusCard.name;
            store.dispatch(ChangeLossControlStatus(status));
            if(this.search){
                let Tempcards = this.FilterCards(this.search);
                store.dispatch(ChangeLossControlCards(JSON.parse(JSON.stringify(Tempcards)), name));
            }else{
                store.dispatch(ChangeLossControlCards(JSON.parse(JSON.stringify(this.cards)), name));
            }
            
            localStorage.setItem('AugenCard'+this.equipamento, JSON.stringify(this.cards));
        } catch (error) {
            console.log(error)
        }
    }

    // Altera o card favorito do usuário 
    changeFavCard(position, focus){
        let currentFocus = this.cards[0].find(card => card.focus === true);
        if(this.cardtochange){
            if(focus){
                currentFocus = this.cardtochange;
            }
            this.cardtochange.focus = focus;
            store.dispatch(ChangeLossControlStatus(this.cardtochange.status));
            if(this.search){
                let Tempcards = this.FilterCards(this.search)
                store.dispatch(ChangeLossControlCards(JSON.parse(JSON.stringify(Tempcards)), currentFocus.name));
            }else{
                store.dispatch(ChangeLossControlCards(JSON.parse(JSON.stringify(this.cards)), currentFocus.name));
            }
            try {
                localStorage.setItem('AugenCard'+this.equipamento, JSON.stringify(this.cards));
            } catch (error) {
                
            }
        }else{
            toast(i18n.t("message.dashboard-service.equipment.change-fav-card"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
        }
    }

    // Pega os dados dos dias
    async getDayData(card, key, name, idEquipment){
        if(card){
            try {
                store.dispatch(ChangeLossControlDaysLoading(true));
                let data = store.getState().DashboardControlePerdasReducer.year + '-' + store.getState().DashboardControlePerdasReducer.month + '-' + store.getState().DashboardControlePerdasReducer.day;
                let flag = store.getState().DashboardControlePerdasReducer.Mode;
                let newData = await this.ControlePerdasRequest.daysRequest(this.equipamento, data, card, flag, key, idEquipment);
                this.formatDayData(newData, name);
                store.dispatch(ChangeLossControlDaysLoading(false));
            } catch (error) {
                console.log(error)
                toast(error.message, {
                    position: "top-center",
                    type: 'error',
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                    theme: config.theme,
                });
                if(error.status === 401){
                    store.dispatch(LogOut());
                }
                this.formatDayData({}, name);
                store.dispatch(ChangeLossControlDaysLoading(false));
                return;
            }
        }
    }

    // Altera o dia
    async changeDay(day, month, year){
        this.ChangeDonut(year + '/' + getDataString(month));
        this.ChangeCards(year + '/' + getDataString(month));
    }

    // Método para alterar o mes/ano
    changeMonthYear(day, month, year){
        this.loadCards(year + '/' + month );
        this.ChangeDonut(year + '/' + month );
    }


    async ChangeCards(data){
        try {
            store.dispatch(ChangeLossControlCardsLoading(true));
            let mewCards = await this.ControlePerdasRequest.CardsRequest(data);
            await this.generateOrderCards(mewCards, true);
            store.dispatch(ChangeLossControlCardsLoading(false));
        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            this.formatDayData({}, 'SD');
            store.dispatch(ChangeLossControlCardsLoading(false));
            return;
        }
    }


    async ChangeDonut(data){
        try {
            let newDonut = await this.ControlePerdasRequest.DonutChart(data);
            store.dispatch(changeLossControlDonutDataTotal(newDonut));
            await this.generateDonut(newDonut);
        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            this.formatDayData({}, 'SD');
            return;
        }
    }

    async generateDonut(newDonut){

         try {

            const chartData = newDonut.map(item => ({
                label: item.name,
                value: item.total
            }));


            store.dispatch(changeLossControlDonutData(chartData));
            return chartData;    

        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            this.formatDayData({}, 'SD');
            return;
        }

    }


    // Gera os cards no formato correto
    async generateOrderCards(newCards, ChangeLossControlDays){
        let Tempcards = {
            0: []
        }
        let oldcards = JSON.parse(localStorage.getItem('AugenCard'+this.equipamento));
        let name;
        if (oldcards) {

            newCards
                .filter(Boolean)
                .forEach(card => {

                    const existsInMain = oldcards[0]?.some(
                        oldcard => oldcard && oldcard.id === card.id && oldcard.key === card.key
                    );

                    if (!existsInMain) {
                        card.Active = true;
                        oldcards[0].push(card);
                    }
                });

            oldcards[0]
                .filter(Boolean)
                .forEach(card => {
                    const temp = newCards.find(
                        newcard => newcard && newcard.id === card.id && newcard.key === card.key
                    );

                    if (temp) {
                        temp.Active = true;
                        temp.focus = card.focus;

                        if (card.focus) {
                            // if (!ChangeLossControlDays) {
                            //     this.getDayData(
                            //         temp.id,
                            //         temp.key,
                            //         temp.name,
                            //         temp.idEquipment
                            //     );
                            // }

                            store.dispatch(ChangeLossControlStatus(temp.status));
                            name = temp.name;
                        }

                        Tempcards[0].push(temp);
                    }
                });


        } else {
            newCards
                .filter(Boolean)
                .forEach((card, index) => {
                    card.Active = true;
                    Tempcards[0].push(card);
                });
        }

        // Verifica se o card que está em foco ainda existe
        if(!name && Tempcards[0]?.length > 0){
            Tempcards[0][0].focus = true;
            name = Tempcards[0][0].name;
            store.dispatch(ChangeLossControlStatus(Tempcards[0][0].status));
        }

        this.cards = Tempcards;
        if(this.search){
            Tempcards = this.FilterCards(this.search);
        }
        store.dispatch(ChangeLossControlCards(JSON.parse(JSON.stringify(Tempcards)), name));
        try {
            localStorage.setItem('AugenCard' + this.equipamento, JSON.stringify(Tempcards));
        } catch (error) {
            
        }
        setTimeout(() => {
            store.dispatch(ChangeLossControlCardsLoading(false));
        }, 5);
    }

   
    // Formata os dados para o gráfico dos dias
    formatDayData(dados, name){
        let values = Object.values(dados);
        let datas = Object.keys(dados);
        let temp = values.map((valor, index) => {
            let hoje = new Date();
            return{
                y: valor,
                x: datas[index].length < 3 ? new Date(hoje.setHours(datas[index])) : new Date(datas[index])
            }
        })
        let data ={
            "id": name ? name : store.getState().DashboardControlePerdasReducer.name,
            "data": temp
        }
        let newdata = [];
        data.data.sort((a, b) => a.x - b.x);
        newdata.push(data);
        store.dispatch(ChangeLossControlDays(newdata));
    }


    FilterCards(search){
        this.search = search;
        let newCards = {
            0: [],
            1: [],
        }
        newCards[0] = this.cards[0]
        this.cards[0].map(card => {
            let nameCard = card.name ? card.name : ''; 
            if(nameCard.toLowerCase().includes(search.toLowerCase())){
                newCards[1].push(card);
            }
            return card;
        })
        this.filteredCards = newCards[0];
        let name = this.cards[0].find(card => card.focus === true).name;
        store.dispatch(ChangeLossControlCards(JSON.parse(JSON.stringify(newCards)), name));
        return JSON.parse(JSON.stringify(newCards));
    }
}